/**
 * Tab Component
 *
 * @file tab.js
 */

import $ from 'jquery';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Isotope from 'isotope-layout';
import 'isotope-layout/dist/isotope.pkgd.min.js';


const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  const defaultTab = () => {
    $('.tab-link-a').on("click", function(){
      $('.tab-link-a').removeClass("active");
      $(this).addClass("active");
      $(".in-item").removeClass("active");
      $(".in-item"+ $(this).attr("href")+"").addClass("active");
      return false;
    });
  };

  const jsTab = () => {
    // external js: isotope.pkgd.js

    // init Isotope
    if($(".grid").is(":visible")){
      var iso = new Isotope( '.grid', {
        itemSelector: '.element-item',
        layoutMode: 'fitRows'
      });

      // bind filter button click
      var filtersElem = document.querySelector('.filters-button-group');
      filtersElem.addEventListener( 'click', function( event ) {
        // only work with buttons
        var filterValue = event.target.getAttribute('data-filter');
        // use matching filter function
        iso.arrange({ filter: filterValue });
      });
      $('.button-group').each( function( i, buttonGroup ) {
        var $buttonGroup = $( buttonGroup );
      });
      $('.button-group button').on( 'click', function() {
        $('.button-group button').removeClass('is-checked');
        $(this).addClass('is-checked');
        AOS.init();
      });
    }

  };

  const init = () => {
    defaultTab();
    jsTab();
  };

  return {
    init,
  };
})();

export default tabs;
